export interface IValidator<T> {
	isValid(val: T): boolean;
}

function currentYear(): number {
	return new Date().getFullYear();
}

export function minYearAllowed(): number {
	return currentYear() - 100;
}

export function maxYearAllowed(): number {
	return currentYear() + 30;
}

export function isYearValid(year: number | null): boolean {
	if (year == null) {
		return false;
	}

	return !(year == null
		|| isNaN(year)
		|| year <= minYearAllowed()
		|| year >= maxYearAllowed());
}